var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "ul",
      { staticClass: "list-unstyled" },
      _vm._l(_vm.attendees, function (attendee, index) {
        return _c(
          "li",
          { key: index },
          [
            _c("event-attendee", {
              attrs: { participant: attendee, index: index },
            }),
            _vm._v(" "),
            _c("hr"),
          ],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.maxParticipantsReached,
            expression: "!maxParticipantsReached",
          },
        ],
      },
      [
        _c(
          "a",
          {
            staticClass: "btn btn-default",
            attrs: { href: "#" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.addAttendee.apply(null, arguments)
              },
            },
          },
          [
            _c("i", { staticClass: "fa fa-plus-square" }),
            _vm._v(
              " " + _vm._s(_vm.$t("event_registration.add_attendee")) + "\n\t\t"
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }